import React, { useState, useRef, useEffect } from "react";
import CodeList from "../lib/CodeList";
import $ from "jquery";
import BuddibleSocket from "../lib/BuddibleSocket";
import Utilities from "../lib/Utilities";
import { Link } from "react-router-dom";
import LogoSvg from "../assets/LogoSvg";
import { useTranslation } from "react-i18next";

window.jQuery = $;
window.$ = $;
global.jQuery = $;
const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

export default function PersonalRegistModal() {
  const [isCertification, setIsCertification] = useState(false);
  const [certification, setCertification] = useState(false);
  const [isEmailChk, setIsEmailChk] = useState(false);
  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);
  const [idChk, setIdChk] = useState(true);
  const [state_AUTH_REQ, setState_AUTH_REQ] = useState(false);
  const [state_AUTH_COMP, setState_AUTH_COMP] = useState(false);
  const [state_EMAIL_COMP, setState_EMAIL_COMP] = useState(false);
  const [check_pwd_length, setCheck_pwd_length] = useState(false);
  const [check_pwd_re, setCheck_pwd_re] = useState(false);
  const { t } = useTranslation();

  const $controllers = {
    USER_ID: useRef(),
    USER_PW: useRef(),
    USER_PW_RE: useRef(),
    USER_NM: useRef(),
    USER_TEL: useRef(),
    USER_AUTH_CODE: useRef(),
    USER_NICK: useRef(),
    USER_PART_NM: useRef(),
    USER_TEAM_NM: useRef(),
    check_userID: idChk,
    check_pwd_length: check_pwd_length,
    check_pwd_re: check_pwd_re,
    state_AUTH_REQ: state_AUTH_REQ,
    state_AUTH_COMP: state_AUTH_COMP,
    state_EMAIL_COMP: state_EMAIL_COMP,
  };

  const $termsController = {
    termsOfUse: useRef(),
    mallOperationPolicy: useRef(),
    talkOperationPolicy: useRef(),
    privacyPolicy: useRef(),
    disclaimer: useRef(),
  };

  function checkEmail(str) {
    const reg_email =
      /^([0-9a-zA-Z_\.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/;
    return reg_email.test(str);
  }

  function joinData(key, data) {
    const retData = {
      COMP_CD: "Y0001",
      USER_ID: $controllers.USER_ID.current.value,
      USER_PW: $controllers.USER_PW.current.value,
      USER_PW_RE: $controllers.USER_PW_RE.current.value,
      USER_NM: $controllers.USER_NM.current.value,
      USER_TEL: $controllers.USER_TEL.current.value,
      // USER_AUTH_CODE: $controllers.USER_AUTH_CODE.current.value,
      USER_NICK: $controllers.USER_NICK.current.value,
      USER_PART_NM: $controllers.USER_PART_NM.current.value,
      USER_TEAM_NM: $controllers.USER_TEAM_NM.current.value,
      check_userID: $controllers.check_userID,
      check_pwd_length: $controllers.check_pwd_length,
      check_pwd_re: $controllers.check_pwd_re,
      state_AUTH_REQ: $controllers.state_AUTH_REQ,
      state_AUTH_COMP: $controllers.state_AUTH_COMP,
      state_EMAIL_COMP: $controllers.state_EMAIL_COMP,
    };

    if (key === "METHOD") {
      retData.METHOD = data;
    }
    if (key === "USER_AUTH_CODE") {
      retData.USER_AUTH_CODE = data;
    }

    return retData;
  }

  function handleChange(key, text) {
    $controllers[key] = text;
  }

  function checkEmailFromServer() {
    let updateData = joinData("METHOD", "CHECK_EMAIL");
    requestUserUpdate(updateData);
  }

  function checkTelFromServer() {
    let updateData = joinData("METHOD", "CHECK_TEL");
    requestUserUpdate(updateData);
  }

  function checkAuthFromServer() {
    let updateData = joinData("METHOD", "CHECK_AUTH");
    if (state_AUTH_REQ) {
      const authcode = $controllers.USER_AUTH_CODE.current.value;
      updateData.USER_AUTH_CODE = authcode;
      requestUserUpdate(updateData);
    }
  }

  function actionSave() {
    const updateData = joinData("METHOD", "INSERT_CUSTOMER");
    if (state_AUTH_REQ && state_AUTH_COMP) {
      const authcode = $controllers.USER_AUTH_CODE.current.value;
      updateData.USER_AUTH_CODE = authcode;
      requestUserUpdate(updateData);
    } else {
      codeList.Modal.current.alert(
        t("commonNav.registrationIndividualModal.msg.enterRequiresInput"),
        () => {}
      );
      return false;
    }
  }

  function checkValidation(updateData) {
    if (updateData.METHOD === "CHECK_EMAIL") {
      if (util.validationEmail(updateData.USER_ID) === false) {
        codeList.Modal.current.alert(
          t("commonNav.registrationIndividualModal.msg.enterEmail"),
          () => {
            $controllers.USER_ID.current.focus();
          }
        );
        return false;
      }
    } else if (updateData.METHOD === "CHECK_TEL") {
      if (util.validationMobileNumber(updateData.USER_TEL) === false) {
        codeList.Modal.current.alert(
          t("commonNav.registrationIndividualModal.msg.enterPhoneNumber"),
          () => {
            $controllers.USER_TEL.current.focus();
          }
        );
        return false;
      }
    } else if (updateData.METHOD === "CHECK_AUTH") {
      if (util.validationMobileNumber(updateData.USER_TEL) === false) {
        codeList.Modal.current.alert(
          t("commonNav.registrationIndividualModal.msg.checkVerificationSMS"),
          () => {
            $controllers.USER_TEL.current.focus();
          }
        );
        return false;
      }
      if (updateData.USER_AUTH_CODE.length !== 6) {
        codeList.Modal.current.alert(
          t("commonNav.registrationIndividualModal.msg.enterVerificationCode"),
          () => {
            $controllers.USER_AUTH_CODE.current.focus();
          }
        );
        return false;
      }
    } else if (updateData.METHOD === "INSERT_CUSTOMER") {
      if (updateData.USER_NM.trim() === "") {
        codeList.Modal.current.alert(
          t("commonNav.registrationIndividualModal.msg.enterName"),
          () => {
            $controllers.USER_NM.current.focus();
          }
        );
        return false;
      }
      if (updateData.USER_NICK.trim() === "") {
        codeList.Modal.current.alert(
          t("commonNav.registrationIndividualModal.msg.enterNickname"),
          () => {
            $controllers.USER_NICK.current.focus();
          }
        );
        return false;
      }

      if (updateData.state_EMAIL_COMP === false) {
        codeList.Modal.current.alert(
          t("commonNav.registrationIndividualModal.msg.checkDuplicateEmail"),
          () => {}
        );
        return false;
      }
      if (updateData.check_pwd_length === false) {
        codeList.Modal.current.alert(
          t("commonNav.registrationIndividualModal.msg.checkPasswordLength"),
          () => {
            $controllers.USER_PW.current.focus();
          }
        );
        return false;
      }

      if (updateData.check_pwd_re === false) {
        codeList.Modal.current.alert(
          t("commonNav.registrationIndividualModal.msg.noSameCheckPassword"),
          () => {}
        );
        return false;
      }
      if (
        updateData.state_AUTH_REQ === false ||
        updateData.state_AUTH_COMP === false
      ) {
        codeList.Modal.current.alert(
          t("commonNav.registrationIndividualModal.msg.checkVerificationSMS"),
          () => {}
        );
        return false;
      }

      for (let key in $termsController) {
        if ($termsController[key].current.checked === false) {
          codeList.Modal.current.alert(
            t("commonNav.registrationIndividualModal.msg.checkTerms"),
            () => {}
          );
          return false;
        }
      }
    } else {
      return false;
    }

    return true;
  }

  function requestUserUpdate(updateData) {
    if (checkValidation(updateData) === false) return;
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/join/JS_join_gbts_private_user.php",
      msgID: msgID,
      data: {},
      ...updateData,
    };
    if (socketMsg.USER_PW !== "") {
      socketMsg.USER_PW = util.buddibleEncrypt(socketMsg.USER_PW);
    }
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        switch (updateData.METHOD) {
          case "CHECK_AUTH":
            if (newData["ret"] === true) {
              handleChange("state_AUTH_COMP", true);
              setMin(0);
              $controllers.USER_AUTH_CODE.current.disabled = true;
              setState_AUTH_COMP(true);
              setCertification(true);
              codeList.Modal.current.alert(
                t(
                  "commonNav.registrationIndividualModal.msg.successVerification"
                ),
                () => {}
              );
            } else {
              codeList.Modal.current.alert(
                t("commonNav.registrationIndividualModal.msg.unVerification"),
                () => {}
              );
            }
            break;
          case "CHECK_EMAIL":
            if (newData["ret"] === true) {
              handleChange("state_EMAIL_COMP", true);
              $controllers.USER_ID.current.disabled = true;
              setState_EMAIL_COMP(true);
              setIsEmailChk(true);
            } else {
              codeList.Modal.current.alert(
                t("commonNav.registrationIndividualModal.msg.alreadyUserEmail"),
                () => {}
              );
            }
            break;
          case "CHECK_TEL":
            if (newData["ret"] === true) {
              setIsCertification(true);
              setMin(3);
              handleChange("state_AUTH_REQ", true);
              setState_AUTH_REQ(true);
            } else {
              codeList.Modal.current.alert(
                t(
                  "commonNav.registrationIndividualModal.msg.alreadyPhoneNumber"
                ),
                () => {}
              );
            }
            break;
          case "INSERT_CUSTOMER":
            if (newData["ret"] === true) {
              codeList.Modal.current.alert(
                t("commonNav.registrationIndividualModal.msg.successJoin"),
                () => {
                  window.location.replace("/");
                }
              );
            } else {
              codeList.Modal.current.alert(
                t("commonNav.registrationIndividualModal.msg.error"),
                () => {}
              );
            }
            break;
        }

        if (updateData.METHOD === "CHECK_EMAIL") {
        }
        if (newData["ret"] === true) {
        }
      }
    });
  }

  // 타이머
  useEffect(() => {
    const countdown = setInterval(() => {
      if (parseInt(sec) > 0) {
        setSec(parseInt(sec) - 1);
      }
      if (parseInt(sec) === 0) {
        if (parseInt(min) === 0) {
          clearInterval(countdown);
        } else {
          setMin(parseInt(min) - 1);
          setSec(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(countdown);
    };
  }, [min, sec]);

  function checkPhone() {
    checkTelFromServer();
  }

  return (
    <div
      className="modal fade"
      id="personalRegistModal"
      tabIndex="-1"
      aria-labelledby="personalRegistModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header" style={{ borderBottom: "none" }}>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="personalRegistModalClose"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="container-fluid">
              <div className="text-lg-center">
                <div id="logo" style={{ marginTop: "-30px" }}>
                  <LogoSvg height="60px" />
                </div>
                <div className="logo  mt-4">
                  <h6 className="m-0 mb-1 text-secondary font-weight-bold">
                    {t("commonNav.registrationIndividualModal.title")}
                  </h6>
                </div>
                {/*아이디 패스워드 입력*/}
                <div className="py-3 d-block">
                  <div className="mb-3 row">
                    <label className="col-form-label col-sm-3 text-end">
                      {t("commonNav.registrationIndividualModal.email")}{" "}
                      <i style={{ color: "red", fontWeight: 700 }}>*</i>
                    </label>
                    <div className="col-sm-9 d-flex flex-row">
                      <input
                        type="email"
                        className="form-control w-auto flex-fill mr-3"
                        placeholder={t(
                          "commonNav.registrationIndividualModal.placeholderEmail"
                        )}
                        ref={$controllers.USER_ID}
                        onChange={(e) => {
                          setIdChk(checkEmail(e.target.value));
                        }}
                      />

                      {!isEmailChk ? (
                        <button
                          className="btn_2"
                          onClick={() => {
                            checkEmailFromServer();
                          }}
                          style={{ width: 115 }}
                        >
                          {t(
                            "commonNav.registrationIndividualModal.checkDuplicateEmail"
                          )}
                        </button>
                      ) : (
                        <button
                          className="btn_1"
                          onClick={() => {
                            $controllers.USER_ID.current.disabled = false;
                            setIsEmailChk(false);
                          }}
                          style={{ width: 115 }}
                        >
                          {t(
                            "commonNav.registrationIndividualModal.changeEmail"
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                  {!idChk ? (
                    <div className="mb-3 row" style={{ marginTop: -10 }}>
                      <label className="col-form-label col-sm-3 text-end"></label>
                      <div className="col-sm-9" style={{ textAlign: "left" }}>
                        <span className="text-danger">
                          {t(
                            "commonNav.registrationIndividualModal.validEmailNotice"
                          )}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  <div className="mb-3 row">
                    <label className="col-form-label col-sm-3 text-end">
                      {t("commonNav.registrationIndividualModal.password")}
                      <i style={{ color: "red", fontWeight: 700 }}>*</i>
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="password"
                        className="form-control"
                        ref={$controllers.USER_PW}
                        onChange={(e) => {
                          if (e.target.value.length > 6) {
                            setCheck_pwd_length(true);
                          }
                        }}
                      />
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="col-form-label col-sm-3 text-end">
                      {t("commonNav.registrationIndividualModal.checkPassword")}
                      <i style={{ color: "red", fontWeight: 700 }}>*</i>
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="password"
                        className="form-control"
                        ref={$controllers.USER_PW_RE}
                        onChange={(e) => {
                          if (
                            e.target.value ===
                            $controllers.USER_PW.current.value
                          ) {
                            setCheck_pwd_re(true);
                          }
                        }}
                      />
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="col-form-label col-sm-3 text-end">
                      {t("commonNav.registrationIndividualModal.name")}{" "}
                      <i style={{ color: "red", fontWeight: 700 }}>*</i>
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        ref={$controllers.USER_NM}
                      />
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="col-form-label col-sm-3 text-end">
                      {t("commonNav.registrationIndividualModal.nickname")}{" "}
                      <i style={{ color: "red", fontWeight: 700 }}>*</i>
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        ref={$controllers.USER_NICK}
                      />
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="col-form-label col-sm-3 text-end">
                      {t("commonNav.registrationIndividualModal.phoneNumber")}{" "}
                      <i style={{ color: "red", fontWeight: 700 }}>*</i>
                    </label>
                    <div className="col-sm-9 d-flex flex-row">
                      <input
                        type="tel"
                        className="form-control w-auto flex-fill mr-3"
                        ref={$controllers.USER_TEL}
                        placeholder={t(
                          "commonNav.registrationIndividualModal.placeholderPhoneNumber"
                        )}
                      />
                      <button
                        className="btn_2"
                        onClick={() => {
                          certification
                            ? codeList.Modal.current.alert(
                                t(
                                  "commonNav.registrationIndividualModal.msg.alreadyVerification"
                                ),
                                () => {}
                              )
                            : checkPhone();
                        }}
                        style={{ width: 130 }}
                      >
                        {t(
                          "commonNav.registrationIndividualModal.sendAuthCode"
                        )}
                      </button>
                    </div>
                  </div>

                  {isCertification ? (
                    <>
                      <div className="mb-1 row">
                        <label className="col-form-label col-sm-3 text-end">
                          {t("commonNav.registrationIndividualModal.authCode")}{" "}
                          <i style={{ color: "red", fontWeight: 700 }}>*</i>
                        </label>
                        <div className="col-sm-7">
                          <input
                            type="text"
                            className="form-control"
                            ref={$controllers.USER_AUTH_CODE}
                          />
                        </div>
                        <button
                          className="btn_2"
                          onClick={() => {
                            certification
                              ? codeList.Modal.current.alert(
                                  t(
                                    "commonNav.registrationIndividualModal.msg.alreadyVerification"
                                  ),
                                  () => {}
                                )
                              : checkAuthFromServer();
                          }}
                          style={{ width: 115, background: "#777777" }}
                        >
                          {t("commonNav.registrationIndividualModal.submit")}{" "}
                        </button>
                      </div>
                      <div className="mb-1 row">
                        <div
                          className="col-sm-12"
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          {min !== 0 ? (
                            <>
                              {min}:{sec < 10 ? `0${sec}` : sec}
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}

                  <div className="mb-3 row">
                    <label className="col-form-label col-sm-3 text-end">
                      {t("commonNav.registrationIndividualModal.compName")}{" "}
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        ref={$controllers.USER_TEAM_NM}
                      />
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="col-form-label col-sm-3 text-end">
                      {t("commonNav.registrationIndividualModal.partName")}{" "}
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        ref={$controllers.USER_PART_NM}
                      />
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="col-form-label col-sm-3 text-end">
                      {t("commonNav.registrationIndividualModal.agreeTerms")}{" "}
                      <i style={{ color: "red", fontWeight: 700 }}>*</i>
                    </label>
                    <div className="col-sm-9">
                      <div className="form-group d-flex flex-row justify-content-start align-items-center text-left mr-2 font-weight-bold">
                        <label className="container_check m-0 p-0 mr-3">
                          <input
                            type="checkbox"
                            className="position-static"
                            onChange={(e) => {
                              let val = e.target.checked;
                              for (let key in $termsController) {
                                if ($termsController[key].current) {
                                  $termsController[key].current.checked = val;
                                }
                              }
                            }}
                          />
                          <span className="checkmark" />
                        </label>
                        {t("commonNav.registrationIndividualModal.agreeAll")}{" "}
                      </div>
                      <div className="d-flex flex-row flex-wrap">
                        <div className="form-group d-flex flex-row justify-content-start align-items-center text-left mr-2">
                          <label className="container_check m-0 p-0 mr-3">
                            <input
                              type="checkbox"
                              className="position-static"
                              ref={$termsController.termsOfUse}
                            />
                            <span className="checkmark" />
                          </label>
                          <Link
                            to="/Terms/termsOfUse"
                            target="_blank"
                            className="align-middle"
                          >
                            {t(
                              "commonNav.registrationIndividualModal.termsOfUse"
                            )}{" "}
                          </Link>
                        </div>
                        <div className="form-group d-flex flex-row justify-content-start align-items-center text-left mr-2">
                          <label className="container_check m-0 p-0 mr-3">
                            <input
                              type="checkbox"
                              className="position-static"
                              ref={$termsController.mallOperationPolicy}
                            />
                            <span className="checkmark" />
                          </label>
                          <Link
                            to="/Terms/mallOperationPolicy"
                            target="_blank"
                            className="align-middle"
                          >
                            {t(
                              "commonNav.registrationIndividualModal.mallOperationPolicy"
                            )}{" "}
                          </Link>
                        </div>
                        <div className="form-group d-flex flex-row justify-content-start align-items-center text-left mr-2">
                          <label className="container_check m-0 p-0 mr-3">
                            <input
                              type="checkbox"
                              className="position-static"
                              ref={$termsController.talkOperationPolicy}
                            />
                            <span className="checkmark" />
                          </label>
                          <Link
                            to="/Terms/talkOperationPolicy"
                            target="_blank"
                            className="align-middle"
                          >
                            {t(
                              "commonNav.registrationIndividualModal.talkOperationPolicy"
                            )}{" "}
                          </Link>
                        </div>
                        <div className="form-group d-flex flex-row justify-content-start align-items-center text-left mr-2">
                          <label className="container_check m-0 p-0 mr-3">
                            <input
                              type="checkbox"
                              className="position-static"
                              ref={$termsController.privacyPolicy}
                            />
                            <span className="checkmark" />
                          </label>
                          <Link
                            to="/Terms/privacyPolicy"
                            target="_blank"
                            className="align-middle"
                          >
                            {t(
                              "commonNav.registrationIndividualModal.privacyPolicy"
                            )}{" "}
                          </Link>
                        </div>
                        <div className="form-group d-flex flex-row justify-content-start align-items-center text-left mr-2">
                          <label className="container_check m-0 p-0 mr-3">
                            <input
                              type="checkbox"
                              className="position-static"
                              ref={$termsController.disclaimer}
                            />
                            <span className="checkmark" />
                          </label>
                          <Link
                            to="/Terms/disclaimer"
                            target="_blank"
                            className="align-middle"
                          >
                            {t(
                              "commonNav.registrationIndividualModal.disclaimer"
                            )}{" "}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn_1"
              onClick={() => {
                actionSave();
              }}
            >
              {t("commonNav.registrationIndividualModal.requestJoin")}{" "}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
